import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function LoadingState() {
  const { t } = useTranslation('tasks');

  return (
    <Box display="flex" alignItems="center" justifyContent="center" py={4}>
      <CircularProgress />
      <Typography variant="body2" sx={{ ml: 2 }}>
        {t('messages.loading_recurrence')}
      </Typography>
    </Box>
  );
}
